export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAfiuVEJOrd-lku0t79peU5wuwNoRJIvC8",
    authDomain: "erpfrontend-7d554.firebaseapp.com",
    projectId: "erpfrontend-7d554",
    storageBucket: "erpfrontend-7d554.appspot.com",
    messagingSenderId: "365013604655",
    appId: "1:365013604655:web:8bc855750adf8404a029da",
    measurementId: "G-LSSR7NF19Y"
  },
  firebaseConfigs: {
    apiKey: "AIzaSyA0Oo1fK_lf41Mh3ZdRkAf6GnjAR9DObOM",
    authDomain: "tushar-a0516.firebaseapp.com",
    projectId: "tushar-a0516",
    storageBucket: "tushar-a0516.appspot.com",
    messagingSenderId: "972627401219",
    appId: "1:972627401219:web:7c9b208b0e6a094e6ccc36",
    measurementId: "G-Z6753EVCBW",
  },
  // LIVE_URL: 'https://test.erp.api.ithemes.xyz'
  // LIVE_URL: 'http://localhost:8085'
  LIVE_URL: 'https://test.erp.api.ithemes.xyz'
  // LIVE_URL: 'https://erp.ithemes.xyz'
}
